import { useNavigate } from "react-router-dom";
import "./styles/Quoting.css";
import {useSelector} from "react-redux";
import {Policy} from "../../objects/policy";
import {useEffect, useState} from "react";
import { RatingResponse } from "../../objects/rating";
import { Document, IssuedPolicy } from "../../objects/issuedPolicy";
import { Link } from "react-router-dom";
import dayjs from 'dayjs';
import { logActivityAsync } from "../../objects/events/loadEvents";

function Complete (){
    let navigate = useNavigate();
    
    var policyStore = useSelector((state:any)=> state.policyReducer as Policy);
    var ratedPolicyStore = useSelector((state:any)=> state.ratedPolicyReducer as RatingResponse);
    var issuedPolicyStore = useSelector((state:any)=> state.issuedPolicyReducer as IssuedPolicy);

    const [policy, setPolicy] = useState<Policy>(new Policy());
    const [dueDate, setDueDate] = useState<string>("");
    const [documents, setDocuments] = useState<Document[]>([]);

    const currencyFormatter = new Intl.NumberFormat('en-US',
    {
        style: 'currency',
        currency: 'USD'
    });

    const renderThankYouMessage = () => {
        if(process.env.REACT_APP_CLIENT === "ALSET"){
            return <>Thank you for purchasing your auto
                    insurance through Alset Insurance Services.
                    Check your email inbox* for your policy
                    documents. Make sure you save your ID cards to
                    your mobile.</>;
        }

        return <>Thank you for purchasing your Ford Insure
                insurance through Alset Insurance Services.
                Check your email inbox* for your policy
                documents. Make sure you save your ID cards to
                your mobile.</>;
    }

    useEffect(() => {
        (async () => {
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Navigation",
                message: "Insured has navigated to the complete screen",
                isException:false,
                error: "",
                level:"INFO",
                isSent: false
            });
        })();
        
    }, []);

    useEffect(()=>{
        if(policyStore === undefined || policyStore == null || issuedPolicyStore === undefined || issuedPolicyStore == null){
            navigate("/" + window.location.search);
        }

        window.scrollTo(0, 0);
        setPolicy(policyStore);

        var firstPayment = issuedPolicyStore.installments[0];
        var installDueDate = new Date(new Date(firstPayment.dueDate).toISOString().replace('.000Z', ''));
        
        var formattedDueDate = installDueDate === undefined || isNaN(installDueDate.getTime()) ? "" : installDueDate.getMonth()+1 + "/" + installDueDate.getDate() + "/" + installDueDate.getFullYear()

        // TODO: Probably need to make this, in some fasion, table driven.
        var displayDocs = issuedPolicyStore.documents.filter((m:Document)=>{
            return m.description === "ID Cards" || m.description === "Dec Page"
        });

        setDocuments(displayDocs);
        setDueDate(formattedDueDate);

    }, [policy]);

    return <>
        <div className="container-quote pt-10 w-[85vw] sm:w-[90vw] md:w-[90vw] lg:w-[90vw] xl:w-[60vw]">
                <div className="grid grid-cols-12 gap-5">                
                    <div className="col-span-12 sm:col-span-12: md:col-span-12 lg:col-span-6 xl:col-span-6">
                        <div className="top-1">
                        <h3 className="text-2xl font-bold">We have received your payment.</h3>
                        <br/>
                        <h3 className="text-lg font-bold">
                            {renderThankYouMessage()}
                        </h3>
                        <br/>
                        <h3 className="text-sm">
                            * If you don't see your documents, check your junk mail.
                        </h3>
                        <br/>
                        <h3 className="text-2xl font-bold pb-5">Now, You are Alset! Drive safe!</h3>
                            <div className="container-review-drivers mt-6">
                                
                                <h3 className="text-2xl font-bold pb-5">Summary</h3>
                                
                                <span className="text-xl text-gray-500 font-bold">Policy Start Date</span>
                                <div className=" clear-both"></div>
                                <span className="">{dayjs(policy.effectiveDate).toDate().toLocaleDateString()}</span>
                                <div className=" clear-both mb-5"></div>
                                <span className="text-xl text-gray-500 font-bold">Paid Today</span>
                                <div className=" clear-both"></div>
                                <span>{currencyFormatter.format(ratedPolicyStore.downPayment)}</span>
                                <div className=" clear-both mb-5"></div>
                                <span className="text-xl text-gray-500 font-bold">Next payment</span>
                                <div className=" clear-both"></div>
                                <span>due {dueDate} - {currencyFormatter.format(ratedPolicyStore.installments.find(m=>m.installmentNumber===0)?.totalDue ?? 0.0)}</span>
                                <div className=" clear-both mb-5"></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-12 sm:col-span-12: md:col-span-12 lg:col-span-6 xl:col-span-6 bg-gray-100 rounded-md pt-5 pl-12 mb-12 sm:mb-12 md:mb-12 lg:mb-12 xl:mb-28 pb-6">
                    <h3 className="mb-5 text-2xl font-bold">Policy Documents</h3>
                        {
                            documents.map((v,i) => {
                                return (
                                    <>
                                        <Link target="_blank" key={v.url} download={v.url} to={v.url} className="text-blue-500 hover:underline hover:underline-offset-4">{v.description}</Link>
                                        <br />
                                    </>
                                )
                            })
                        }
                    </div>
                </div>
        </div>
    </>;
}

export default Complete;